import { Component } from '@angular/core';
import { AppPipesModule } from '../app-pipes.module';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
  standalone: false
})
export class AboutComponent {

}
